import moment from "moment";
import { Link } from "react-router-dom";
import MainBtn from "../components/Button.jsx";
import TransferMDTLeadPop from "../components/popups/expertActionBars/Transfer_MDT_Lead_Pop.jsx";
import clsx from "clsx";

export const patientCaseListTable = (e, t, caseInProgress, downloadInvoice) => [
  {
    label: e.name,
    className: `w-25 ${
      e.vc_token
        ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
        : ""
    }`,
  },
  {
    label: e.state,
    className: e.vc_token
      ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
      : "",
  },
  {
    label: e.patient_name,
    className: e.vc_token
      ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
      : "",
  },
  {
    label: (
      <div className="d-flex gap-3">
        <u className="green-txt">
          <Link
            className="green-txt fw-bold text-capitalize"
            to={caseInProgress ? `../newcase?id=${e.patient_id ?? e.id}` : `../case/${e.id}`}
          >
            {caseInProgress
              ? t("case_list.continue_case")
              : t("case_list.view")}
          </Link>
        </u>
        {e.has_invoice === true && (
          <button
            type="button"
            className="green-txt fw-bold text-decoration-underline bg-transparent border-0 p-0"
            onClick={() => downloadInvoice(e.id)}
          >
            {t("case_list.download_invoice")}
          </button>
        )}
        {e.vc_token && (
          <u className="red-txt">
            <Link className="red-txt fw-bold" to={"/vc/" + e.vc_token}>
              join call
            </Link>
          </u>
        )}
      </div>
    ),
    className: e.vc_token
      ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
      : "",
  },
];

export const expertCaseListTable = (e, t, downloadInvoice) => [
  {
    label: e.name,
    className: `w-25 ${
      e.vc_token
        ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
        : ""
    }`,
  },
  {
    label: e.patient_first_name,
    className: e.vc_token
      ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
      : "",
  },
  {
    label: e.patient_last_name,
    className: e.vc_token
      ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
      : "",
  },
  {
    label: e.assign_expert_date
      ? moment(e.assign_expert_date).format("DD/MM/YYYY")
      : "no date available",
    className: e.vc_token
      ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
      : "",
  },
  {
    label: e.acceptation_date
      ? moment(e.acceptation_date).format("DD/MM/YYYY")
      : "no date available",
    className: e.vc_token
      ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
      : "",
  },
  {
    label: e.state,
    className: e.vc_token
      ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
      : "",
  },
  {
    label: (
      <p className="text-danger">
        {e.entity_service_type && e.entity_service_type.toUpperCase()}
      </p>
    ),
    className: e.vc_token
      ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
      : "",
  },
  {
    label: (
      <div className="d-flex gap-3">
        <u className="green-txt">
          <Link className="green-txt fw-bold" to={`../case/${e.id}`}>
            {t("case_list.view")}
          </Link>
        </u>
        {e.has_invoice === true && (
          <button
            type="button"
            className="green-txt fw-bold text-decoration-underline bg-transparent border-0 p-0"
            onClick={() => downloadInvoice(e.id)}
          >
            {t("case_list.download_invoice")}
          </button>
        )}
        {e.vc_token && (
          <u className="red-txt">
            <Link className="red-txt fw-bold" to={"/vc/" + e.vc_token}>
              join call
            </Link>
          </u>
        )}
      </div>
    ),
    className: e.vc_token
      ? "call-inprogress animate__animated animate__flash animate__infinite animate__slow"
      : "",
  },
];

export const medicineTable = (medicine) => [
  { label: medicine.name },
  { label: medicine.dose },
  { label: medicine.frequency },
  { label: medicine.duration },
  { label: medicine.indication_of_use },
];

export const operationTable = (data) =>
  Object.entries(data).map(([key, value]) => ({ label: value }));

export const vcTable = (data, t) => [
  {
    label: (
      <>
        <span
          className={clsx({
            "text-decoration-line-through text-danger":
              data.expired && !data.confirmed,
          })}
        >
          {moment(data.slot_date).format("DD/MM/YYYY")}
        </span>{" "}
        {data.expired && !data.confirmed && (
          <span className="ms-3 text-danger">{t("expired")}</span>
        )}
      </>
    ),
  },
  { label: moment(data.slot_date).format("h:mm A") },
  { label: data.confirmed ? "accepted" : "pending" },
];

export const mdtTable = (e, removeExpert, caseDetails, t, isCaseClosed) => {
  let obj = caseDetails?.mdt_settings?.enable_mdt_team_accept_reject
    ? [
        { label: e.name },
        { label: e.sub_specialization },
        { label: e.acceptance_status },
      ]
    : [{ label: e.name }, { label: e.sub_specialization }];

  isCaseClosed &&
    obj.push({
      label: (
        <div className="d-flex gap-5">
          <TransferMDTLeadPop
            exId={e}
            trigger={{
              txt: t("case_view.btns.transfer_leadership"),
              style:
                "text-decoration-underline bg-transparent text-nowrap p-0 text-start green-txt",
            }}
          />
          <MainBtn
            style="text-decoration-underline bg-transparent red-txt p-0 text-start"
            txt={t("remove")}
            action={() => removeExpert(e.expert_id)}
          />
        </div>
      ),
    });
  return obj;
};
